
import { Helmet } from "react-helmet";
import Products from "../../components/products/products";

export default function ViewAllTrending() {
    return (
        <>
            <Helmet>
                <title>SHOP.CO | New Arrivals - Explore the Latest Products</title>

                <link
                    rel="canonical"
                    href="https://shop-co-roan.vercel.app/view-all-newArrivals/"
                />

            </Helmet>

            <Products endPoint="trending-products" pageType="New Arrivals" initialFilters={{ isTrending: true }} />
        </>
    )
}